import type { SubjectCode, PriorityLevel, TrendDirection, DifficultyLevel } from '../types'

// Subject Colors
export const SUBJECT_COLORS: Record<SubjectCode, string> = {
  NEET_UG_PHY: '#3B82F6',   // Blue
  NEET_UG_CHEM: '#10B981', // Green
  NEET_UG_BIO: '#F59E0B',   // Orange
}

export const SUBJECT_BG_COLORS: Record<SubjectCode, string> = {
  NEET_UG_PHY: '#EFF6FF',   // Blue-50
  NEET_UG_CHEM: '#ECFDF5', // Green-50
  NEET_UG_BIO: '#FFFBEB',   // Amber-50
}

export const SUBJECT_NAMES: Record<SubjectCode, string> = {
  NEET_UG_PHY: 'Physics',
  NEET_UG_CHEM: 'Chemistry',
  NEET_UG_BIO: 'Biology',
}

// Priority Colors
export const PRIORITY_COLORS: Record<PriorityLevel, string> = {
  HIGH: '#EF4444',   // Red
  MEDIUM: '#F59E0B', // Amber
  LOW: '#6B7280',    // Gray
}

export const PRIORITY_BG_COLORS: Record<PriorityLevel, string> = {
  HIGH: '#FEF2F2',   // Red-50
  MEDIUM: '#FFFBEB', // Amber-50
  LOW: '#F9FAFB',    // Gray-50
}

// Trend Colors
export const TREND_COLORS: Record<TrendDirection, string> = {
  INCREASING: '#10B981', // Green
  DECREASING: '#EF4444', // Red
  STABLE: '#6B7280',     // Gray
  NEW: '#8B5CF6',        // Purple
  IRREGULAR: '#F59E0B',  // Amber
}

export const TREND_BG_COLORS: Record<TrendDirection, string> = {
  INCREASING: '#ECFDF5', // Green-50
  DECREASING: '#FEF2F2', // Red-50
  STABLE: '#F9FAFB',     // Gray-50
  NEW: '#F5F3FF',        // Purple-50
  IRREGULAR: '#FFFBEB',  // Amber-50
}

export const TREND_LABELS: Record<TrendDirection, string> = {
  INCREASING: 'Rising',
  DECREASING: 'Declining',
  STABLE: 'Stable',
  NEW: 'New',
  IRREGULAR: 'Irregular',
}

// Difficulty Colors
export const DIFFICULTY_COLORS: Record<DifficultyLevel, string> = {
  EASY: '#10B981',   // Green
  MEDIUM: '#F59E0B', // Amber
  HARD: '#EF4444',   // Red
}

export const DIFFICULTY_BG_COLORS: Record<DifficultyLevel, string> = {
  EASY: '#ECFDF5',   // Green-50
  MEDIUM: '#FFFBEB', // Amber-50
  HARD: '#FEF2F2',   // Red-50
}

// Chart Colors (for Recharts)
export const CHART_COLORS = {
  primary: '#3B82F6',
  secondary: '#10B981',
  tertiary: '#F59E0B',
  quaternary: '#8B5CF6',
  danger: '#EF4444',
  muted: '#6B7280',
  grid: '#E5E7EB',
  background: '#F9FAFB',
}

// Confidence Level Colors
export const CONFIDENCE_COLORS = {
  HIGH: '#10B981',
  MEDIUM: '#F59E0B',
  LOW: '#6B7280',
}

// Pie Chart Specific Colors (trend distribution)
export const TREND_PIE_COLORS = [
  { name: 'INCREASING', color: '#10B981' },
  { name: 'DECREASING', color: '#EF4444' },
  { name: 'STABLE', color: '#6B7280' },
  { name: 'NEW', color: '#8B5CF6' },
]

// Difficulty Pie/Area Chart Colors
export const DIFFICULTY_CHART_COLORS = [
  { name: 'EASY', color: '#10B981' },
  { name: 'MEDIUM', color: '#F59E0B' },
  { name: 'HARD', color: '#EF4444' },
]
